module.exports = __webpack_public_path__ + "img/1.0ff87956.jpg";